<template>
  <div class="history-view scroll-contents">
    <header>
      <h1>着信履歴</h1>
      <div class="display-toggle-controll">
        <span class="show-all" :class="{on: displayState !== 'missed'}" @click="displayModeAll">すべて</span>
        <span class="show-missed" :class="{on: displayState == 'missed'}" @click="displayModeMissed">不在着信</span>
      </div>
    </header>
    <div class="history-column">
      <div class="account-notify-message" v-if="!currentUser || currentUser.state !== 2">
        利用可能なユーザーがいません。
      </div>
      <div class="history-block"
        v-for="history in displayHistories"
        :key="'histent' + history.id">
        <history-column
          :currentUser="currentUser"
          :availableUsers="availableUsers"
          :history="history"
          :displayState="displayState"
          v-on:phoneCallBackEvent="phoneCallBack"
          v-on:showAttendeeDesciptionEvent="showAttendeeDesciption"
          />
      </div>
    </div>
    <history-description-modal 
      :callTarget="callTarget"
      :attendee="targetAttendee"
      :modalFrameDisplay="historyDescriptionModalDisplay"
      v-on:addAddressBookEvent="addAddressBook"
      v-on:phoneCallBackEvent="phoneCallBack"
      v-on:closeEvent="closeHistoryDescriptionModal"
      />
    <select-address-category-modal
      :modalDisplay="selectCategoryDisplay"
      :currentCategory="targetCategory"
      :disableCategories="disableCategories"
      v-on:categorySelectedEvent="categorySelected"
      v-on:closeModalEvent="closeSelectCategory"
      />
    <confirm-dialog
      :showDialog="confirmDialogVisible"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
      :dialogType="confirmDialogType"
      v-on:negativeResultEvent="confirmFinishNegative"
      v-on:positiveResultEvent="confirmFinishPositive"
      />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import HistoryColumn from '@/components/appView/history/HistoryColumn.vue'
import HistoryDescriptionModal from '@/components/appView/history/HistoryDescriptionModal.vue'
import SelectAddressCategoryModal from '@/components/appView/common/SelectAddressCategoryModal.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

import ConfirmDialogControll from '@/mixin/ConfirmDialogControll'

export default {
  mixins: [ConfirmDialogControll],

  name: 'HistoryView',

  components: {
    HistoryColumn,
    HistoryDescriptionModal,
    SelectAddressCategoryModal,
    ConfirmDialog,
  },

  emits: [
    'prepareCallEvent',
  ],

  data () {
    return {
      displayHistories: [],
      displayState: 'all',
      historyDescriptionModalDisplay: false,
      callTarget: null,
      targetAttendee: null,
      selectCategoryDisplay: false,
      targetCategory: null,
      disableCategories: [],
    }
  },

  mounted() {
    this.displayHistories = this.callHistories
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      availableUsers: state => state.user.users,
      addressBook: state => state.addressBook.addressCategories,
      callHistories: state => state.callHistory.histories,
    }),

    ...mapGetters({
      storedEntryWithCategory: 'addressBook/storedEntryWithCategory',
      categorySelectable: 'addressBook/categorySelectable',
      notIncludedCategories: 'addressBook/notIncludedCategories',
      allCategoryIncluded: 'addressBook/allCategoryIncluded',
    }),

    missedHistories () {
      let filtered = []
      for(const history of this.callHistories) {
        if (!this.availableUsers.some((user) => user.narrative_phone_id === history.owner)) {
          for(const attendee of history.attendees) {
            for (const user of this.availableUsers) {
              if (user.narrative_phone_id === attendee.narrative_phone_id
                && !attendee.joined
                && !filtered.some((fHistory) => fHistory.id === history.id)
              ) {
                filtered.push(history)
              }
            }
          }
        }
      }
      filtered.sort((f, s) => f.triggered_at < s.triggered_at ? 1 : -1)
      return filtered
    },
  },

  methods: {
    ...mapActions({
      switchAccount: 'user/switchAccount',
      fetchAddressBook: 'addressBook/fetch',
      createEntry: 'addressBook/createEntry',
      fetchCallHistory: 'callHistory/fetch',
      loadMoreCallHistory: 'callHistory/loadMore',
    }),

    displayModeAll () {
      this.fetchCallHistory()
      this.displayHistories = this.callHistories
      this.displayState = 'all'
    },

    displayModeMissed () {
      this.fetchCallHistory()
      this.displayHistories = this.missedHistories
      this.displayState = 'missed'
    },

    phoneCallBack(account_name, attendees) {
      console.log(attendees)
      this.$emit('prepareCallEvent', account_name, attendees)
    },

    async showAttendeeDesciption (callTarget, attendee) {
      await this.switchAccount(callTarget.account_name)
      await this.fetchAddressBook()
      this.callTarget = callTarget
      this.targetAttendee = attendee
      this.historyDescriptionModalDisplay = true
    },

    closeHistoryDescriptionModal () {
      this.historyDescriptionModalDisplay = false
      this.targetAttendee = null
      this.callTarget = null
    },

    addAddressBook () {
      console.log('addAddressBook call,')
      if (this.targetAttendee) {
        this.disableCategories = []
        this.disableCategories = this.notIncludedCategories(this.targetAttendee.narrative_phone_id)
        if (this.allCategoryIncluded(this.targetAttendee.narrative_phone_id)) {
          // target includes all category
          this.showNotifyDialog("連絡先登録不可", 'すでに登録済みのため、連絡先への登録はできません。')
        } else {
          if (this.categorySelectable) {
            this.selectCategoryDisplay = true
          } else {
            console.log(this.addressBook[0])
            this.executeAddAddress(this.addressBook[0])
          }
        }
      }
    },

    categorySelected (category) {
      this.selectCategoryDisplay = false
      this.executeAddAddress(category)
    },

    executeAddAddress (category) {
      console.log('execute add address')
      let formData = new FormData()
      formData.append('narrative_phone_id', this.targetAttendee.narrative_phone_id)
      formData.append('address_category_id', category.id)
      this.createEntry(formData).then(() => {
        this.targetCategory = null
        this.showNotifyDialog("連絡先登録", 'グループ' + category.name + 'に登録しました。')
      }).catch(error => {
        console.log(error)
        this.targetCategory = null
        this.showNotifyDialog("登録の失敗", '連絡先への登録に失敗しました。')
      })
    },

    closeSelectCategory () {
      this.selectCategoryDisplay = false
    },

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.history-view {
  margin: 0;
  height: 100%;
  header {
    border-bottom: 1px solid #aaa;
    align-items: flex-end;
    height: calc(65px - 20px - 10px - 1px);
    .display-toggle-controll {
      border: 1px solid #aaa;
      border-radius: 5px;
      .show-all {
        display: inline-block;
        padding: 3px 5px;
        border-right: 1px solid #aaa;
        border-radius: 5px 0 0 5px;
        width: 80px;
        text-align: center;
        background-color: #aaa;
        font-weight: normal;
        &.on {
          background-color: #fff;
          font-weight: bold;
        }
      }
      .show-missed {
        display: inline-block;
        padding: 3px 5px;
        width: 80px;
        text-align: center;
        border-radius: 0 5px 5px 0;
        background-color: #aaa;
        font-weight: normal;
        &.on {
          background-color: #fff;
          font-weight: bold;
        }
      }
    }
  }
  .history-column {
    height: calc(100% - (65px));
    overflow: auto;
    .account-notify-message {
      padding: 50px 0;
      color: $danger-color;
      text-align: center;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
}
</style>